<template>
    <div class="well-mk-blast-panel">
        <div class="mk-blast-tab-buttons pt-2 mb-2">
            <b-button
                variant="tab"
                class="w-50"
                :pressed="mode === 'annotated_events'"
                @click="changeMode('annotated_events')"
            >
                {{ $translate('annotated_events') }}
            </b-button>

            <b-button
                v-b-tooltip.hover
                :title="$translate('coming_soon')"
                class="w-50"
                variant="tab"
                :pressed="mode === 'blast_info'"
                @click="changeMode('blast_info')"
            >
                {{ $translate('blast_info') }}
            </b-button>
        </div>

        <morphokinetics-table
            v-if="mode === 'annotated_events'"
            class="w-100 mt-2"
            :well="well"
            :current-event="currentEvent"
            @eventChosen="emitEventChosen"
        />

        <blast-info
            v-if="mode === 'blast_info'"
            class="w-100 mt-3"
            :well="well"
            :is-demo="isBlastDemo"
        />
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import MorphokineticsTable from './MorphokineticsTable'
import BlastInfo from './BlastInfo'

export default {
    name: 'WellMkBlastPanel',
    components: {
        BlastInfo,
        MorphokineticsTable
    },
    props: {
        well: {
            type: Object,
            required: true
        },
        currentEvent: {
            type: Object,
            default: null
        }
    },
    data: () => ({
        mode: 'annotated_events'
    }),
    computed: {
        ...mapState({
            selectedTreatment: state => state.timelapse.selectedTreatment
        }),
        isBlastDemo() {
            const { slides } = this.selectedTreatment
            const slide = slides.find(_slide => _slide._id === this.well.slideId)

            return this.well.esId === '1' && slide.esId === 'S01733'
        }
    },
    methods: {
        changeMode(mode) {
            if (mode === 'blast_info' && !this.isBlastDemo) {
                return
            }

            this.$log.actionEvent('right_side_panel_mode', mode)
            this.mode = mode
        },
        emitEventChosen(event) {
            this.$emit('eventChosen', event)
        }
    }
}
</script>

<style lang="scss">
.well-mk-blast-panel {
    // height: 100%;
    display: flex;
    flex-direction: column;
    background-color: $dark-3;
    border-radius: $border-radius-lg;

    .mk-blast-tab-buttons {
        width: 100%;
        display: flex;
    }
}
</style>
